import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {ThemeProvider,Notification} from '@workboard/wobo-ui';
import Modal from '../../../styled-base/modal';
import UnsplashImages from './unsplash';
import ColorBoxes from './colorbox';
import BoardConst from '../../utils/constants/board';
import {BoardContainerProps} from '../../types/board.types';
import {ColumnHeader, NormalColumnHeader} from './column-header';
import HelpTextComp from '../../../components/helper/helptext.component';
import {useDispatch} from 'react-redux';
import {changeMenuBoardTheme, changeMenuBoardColumnHeader, changeBoardState} from '../../actions/menu.action';
import Button from '../../../styled-base/button';
import BoardService from '../../services/board.service';

interface BoardSettingsModalProps extends BoardContainerProps
{
    onClose?: () => void
}

const BoardSettingsModal = (props: BoardSettingsModalProps) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const boardService = new BoardService();
    const { boardView, boardDetails } = props;
    let { boardType, wsPermissions, columns=[], userPermission, 
        appyToAllWs = false, boardSettings = {} } = boardDetails;
    const { is_manager, is_co_manager, is_team_admin} = wsPermissions || {};
    const [theme, setBoardTheme]= React.useState<any>(boardSettings.theme);
    const [applyAllWs, setApplyAllWs] = React.useState<boolean>(appyToAllWs);
    const [columnModify, setColumnModify] = React.useState<any>([]);
    const [initialValues, setInitivalValues] = React.useState<any>([]);
    let access: boolean = false;
    let privateBoardWs: boolean = false;
    if (boardView == BoardConst.BOARD_VIEW_ACTIVITY) {
        access = (is_manager || is_co_manager || is_team_admin);
        privateBoardWs = boardDetails.teamId != null;
    } else {
        access = (userPermission.editBoard == '1');
    }
    if (Array.isArray(columns)) {
        columns = columns.filter((column: any) => typeof column.id !== 'undefined' && column.id.indexOf("new_col_") === -1);
    }
    const [showNotif, setNotif] = useState({
      message: "",
      severity: ""
    });
  
    const closeSettingsModal = () => {
       if (Object.keys(initialValues).length) {
            let clearStates: any = {theme: {}, columns: []};
            for(let i in initialValues) {
                if (i == 'theme') {
                  clearStates[i] = initialValues[i];
                }
                else if (i.indexOf('col_color_') !== -1) {
                  clearStates['columns'].push({
                     id: i.split('_')[2],
                     color: initialValues[i]
                  })
                }
            }
            console.log('clearStates', clearStates);
            dispatch(changeBoardState('reset', clearStates));
       }
       props.onClose();
    }
    const onChangeColumnNames = (e: any) => {
        //console.log('columnNames', {...columnModify, [e.target.name]: e.target.value });
        setColumnModify({...columnModify, [e.target.name]: e.target.value });
    }

    const onToggleColumnHide = (e: any) => {
        const onOff = e.target.checked ? 'on' : 'off';
        //console.log('columnNames', {...columnModify, [e.target.name]: onOff });
        setColumnModify({...columnModify, [e.target.name]: onOff});
    }

    const setTheme = (e: any, themeName: string, value: string) => {
        let modifiedTheme: any = {themeName: '', themeImg: '', themeColor: ''};
        if (themeName) {
          if (typeof initialValues[`theme`] === 'undefined') {
            setInitivalValues({...initialValues,  [`theme`]: theme});
          }
          modifiedTheme[themeName]= value;
          setBoardTheme(modifiedTheme);
          dispatch(changeMenuBoardTheme(modifiedTheme));
        }
    }

    const applayColColur = (item: any) => {
        //console.log('applayColColur', item);
        setColumnModify({...columnModify, [item.name]: item.color});
        if (typeof initialValues[`col_color_${item.columnId}`] === 'undefined') {
          setInitivalValues({...initialValues,  [`col_color_${item.columnId}`]: item.columnColor});
        }
        dispatch(changeMenuBoardColumnHeader(item.columnId, item.color));
    }

    const onSave = async() => {
       console.log('onsave');
       let {tagId, teamId, board, columns = []} = boardDetails;

       columns = columns.filter((column: any) => typeof column.id !== 'undefined' && column.id.indexOf("new_col_") === -1);

       let params: any = {
         boardView,
         boardType,
         hasAcess: access,
         theam_color: theme.themeColor,
         theam_name: '',
         theam_img: (theme.themeName ? theme.themeName : theme.themeImg)
       };
       if (boardView == BoardConst.BOARD_VIEW_ACTIVITY) {
          params.tagId = tagId;
          params.teamId = teamId;
          if (boardType == BoardConst.WS_BOARD_TYPE_PROGRESS) {
             columns.map((d: any) => {
                 let defaultTile = d.defaultTile.toLowerCase();
               let t = columnModify[`col_name_${d.id}`] || d.title;

                 d.title = t===""?d.defaultTile:t;
                 params[`board_${defaultTile}`] = t===""?d.defaultTile:t;
                 if (d.id == '2' || d.id == '4') {
                    const columnVisible = columnModify[`col_name_hide_${d.id}`] || d.visible;
                    params[`board_${defaultTile}_visible`] = columnVisible;
                    d.visible = columnVisible;
                 }
                 return d;
              });
              if (applyAllWs) {
                  params['apply_to_all'] = 'on';
              }
              if (columnModify['customConvert'] == 'on') {
                 params['customConvert'] = columnModify['customConvert'];
              }
          }
          else { // BoardConst.WS_BOARD_TYPE_CUSTOM
            columns.map((d: any) => {
                params[`col_color_${d.id}`] = columnModify[`col_name_color_${d.id}`] ? columnModify[`col_name_color_${d.id}`] :
                    d.color;
                return d;
              });
          }
       }
       else { // BoardConst.BOARD_VIEW_SHARED
           if (columns && boardType == BoardConst.WS_BOARD_TYPE_CUSTOM) {
               columns.map((d: any) => {
                   params[`col_color_${d.id}`] = columnModify[`col_name_color_${d.id}`] ? columnModify[`col_name_color_${d.id}`] :
                       d.color;
                   return d;
               });
           }
           params.board_id = board.id;
       }

       params['col_id'] = columns.map((d: any) => d.id).join(',');
       console.log('params', params);
       showLoaderWidget(document.getElementById("content"));
       try {
         await boardService.saveBoardPreference(params);
         props.onClose();
         if (columnModify['customConvert'] == 'on') {
           triggerLeftMenu(
             `${wbConfig.baseUrl}/activity/workstreams?id=${tagId}`,
             false,
             "menu-wb-workstreams"
             );
            } else {
              dispatch(changeBoardState('update', {columns, theme, appyToAllWs: applyAllWs}));
            }
        }
        catch(e) {
          setNotif({
            message: t("Error while saving workstream details. Please try again later"),
            severity: "error"
          })
        }
        finally {
          removeLoaderWidget()
        }
    }

    
    return (
      <>
        <Modal width={600} classes='portal-modal-board-settings'>
          <Modal.Header onClose={() => closeSettingsModal()}>
                <div>{t('Board Settings')}</div>
            </Modal.Header>
            <Modal.Content>
            <div>
              <div id="wsBoardSettings" >
                <ColorBoxes
                    setTheme={setTheme}
                    theme={theme}
                />
                <UnsplashImages
                  setTheme={setTheme}
                  theme={theme}
                />
                 {
                 (access && boardView == BoardConst.BOARD_VIEW_ACTIVITY &&
                    boardType == BoardConst.WS_BOARD_TYPE_PROGRESS) && (
                        <div className="wsBoardColTextDiv">
                        <div>
                          <div className="wsBoardChooseThemeText">{t('Columns')}</div>
                          {columns.map((column: any) => 
                            <NormalColumnHeader
                                key={`normal-${column.id}`}
                                column={column}
                                columnName={columnModify[`col_name_${column.id}`]}
                                onChangeName={onChangeColumnNames}
                                isChecked={(columnModify[`col_name_hide_${column.id}`] == undefined ? (column.visible != 'off') : (columnModify[`col_name_hide_${column.id}`] != 'off'))}
                                onToggleBox={onToggleColumnHide}
                            />
                          )
                          }
                        </div>
                        {privateBoardWs && (
                          <div className="wsBoardDoneColTextWrapper">
                            <div className="displayInlineB theamSubHead wsBoardColCheckboxDiv">
                              <input
                                type="checkbox"
                                id="wsBoardApplyWs"
                                className="inpTheamColumName"
                                name="apply_to_all"
                                checked={applyAllWs}
                                onChange={() => setApplyAllWs(!applyAllWs)}
                              />
                              <label
                                htmlFor="wsBoardApplyWs"
                                className="applyAllWsLabel"
                              >
                                {t('Apply to all workstreams on this team')}
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                    )
                 }
                {
                   (access  &&
                   ((boardType != BoardConst.WS_BOARD_TYPE_PROGRESS &&
                     boardView == BoardConst.BOARD_VIEW_ACTIVITY) ||
                     boardView == BoardConst.BOARD_VIEW_SHARED) && columns.length) ?
                     (
                        <div className="wsBoardColTextDiv">
                        <div>
                          <div className="wsBoardChooseThemeText">
                            {t('Change column header color')}
                          </div>
                          <div className="colColorWrap">
                            {columns.map(
                              (column: any) =>
                                <ColumnHeader
                                    key={column.id}
                                    column={column}
                                    columnColor={columnModify[`col_name_color_${column.id}`]}
                                    applayColColur={applayColColur}
                                />
                            )}
                          </div>
                        </div>
                      </div>
                     )
                     :''
                }
              </div>
            </div>
            </Modal.Content>
            <Modal.Footer>
            {(access &&
                boardType == BoardConst.WS_BOARD_TYPE_PROGRESS &&
                boardView == BoardConst.BOARD_VIEW_ACTIVITY) && (
                    <div >
                    <div >
                        <span>{t('Custom board type')}</span>
                        <HelpTextComp>
                            <div>
                                {t('Changing this board to a custom board will allow you to add additional columns and customize your flow.')}
                            </div>
                        </HelpTextComp>
                    </div>
                    <div className="convertToCustomBoardSel">
                        <input
                            type="checkbox"
                            name="customConvert"
                            id="customConvert"
                            checked={(columnModify['customConvert'] == undefined ? false : (columnModify['customConvert'] != 'off'))}
                            onChange={e => onToggleColumnHide(e)}
                        />
                        <label htmlFor="customConvert">
                        <div className="labelDiv">
                            {t('Convert board to a custom board (with customizable columns)')}
                            <br />
                            {t('Note: This change cannot be undone')}
                        </div>
                        </label>
                    </div>
                    </div>
                )}
                <div style={{float: 'right', paddingTop: '10px', width: '60px'}}>
                  <Button type="primary" onClick={() => onSave()} >
                    {t('Save')}
                  </Button>
                </div>
            </Modal.Footer>
        </Modal>
        <ThemeProvider>
          <Notification
            open={Boolean(showNotif.message)}
            message={showNotif.message}
            severity={showNotif.severity}
            anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
            onClose={() => setNotif({
              message: "",
              severity: ""
            })}
          />
        </ThemeProvider>
      </>
    )
}


export default BoardSettingsModal;
